// extracted by mini-css-extract-plugin
export var callCard = "_o6-0";
export var callMessageButton = "_o6-1";
export var helpIcon = "_o6-3";
export var helpIconContainer = "_o6-4";
export var verticalDivider = "_o6-2";